<template>
  <div class="home-container">
    <div class="flex-container">
      <!-- 轮播图 -->
      <div class="left-div"> 
        <div class="top-container">
          <h2 class="top-title">部门介绍</h2>
          <p class="top-description">中国华西企业股份有限公司智能建造技术中心为股份公司下属二级机构。引领和统筹集团BIM技术应用和发展,全面提升集团BIM技术水平;打造工程全生命周期的BIM集成应用综合能力,形成技术核心竞争力;充分发挥BIM技术特点,助力集团数字化转型，实现精细化、标准化管理以及工程建设组织方式和建造方式变革;通过BIM技术充分挖掘数字资源,形成成本优先的市场核心竞争。</p>
          <!-- 上容器内容 -->
        </div>
        <div class="bottom-container">
          <h2 class="top-title" style="margin-bottom: 40px;">最新动态</h2>
          <div class="link-container">
            <el-link underline="false" v-for="(link, index) in links" :key="index" :href="link.url" class="vertical-link">{{ link.text }}</el-link>
          </div>
        </div>
      </div>
      <el-carousel height="800px">
        <el-carousel-item v-for="item in 7" :key="item">
          <img :src="require(`../assets/home/${item}.png`)" class="carousel-img">
        </el-carousel-item>
      </el-carousel>
      <!-- 右侧新 div -->
      
    </div>
    <!-- 内容卡片 -->
    <div class="card-container">
      <el-row :gutter="20">
        <el-col :span="8" v-for="(card, index) in cards" :key="index">
          <el-card :body-style="{ padding: '0px' }">
            <img :src="card.img" class="card-image">
            <div style="padding: 14px;">
              <span>{{ card.title }}</span>
              <div class="bottom">
                <el-button type="text" class="button">查看详情</el-button>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '1',
      cards: [
        { title: '技术服务', img: 'https://picsum.photos/300/200?random=1' },
        { title: '成功案例', img: 'https://picsum.photos/300/200?random=2' },
        { title: '获得荣誉', img: 'https://picsum.photos/300/200?random=3' }
      ],
      links: [
        { text: '***行业速递 | 安徽2025版房建市政工程施工招标范本升级亮相', url: 'https://example.com/link1' },
        { text: '***行业速递 | 上海市BIM审查系统全面升级，6月15日起启用', url: 'https://example.com/link2' },
        { text: '***从"卡壳"到"加速"！这项民生工程凭这套“技术组合拳”破解机房困局！', url: 'https://example.com/link3' },
        { text: '***看BIM技术如何让钢筋工程"斤两必争"？', url: 'https://example.com/link3' }, 
        { text: '***行业速递 | 《上海市建筑信息模型技术应用指南（2025版）》发布用', url: 'https://example.com/link1' },
        { text: '***BIM邂逅地下管网：地下工程迈向"全透明"时代！', url: 'https://example.com/link2'}
      ]
    }
  }
}
</script>

<style scoped>
.home-container {
  width: 100%;
  overflow: hidden;
}

.flex-container {
  display: flex;
  gap: 20px;
  padding: 20px;
}

.el-carousel {
  width: 1400px;
  flex: none;
}

.left-div {
  flex: 1;
  background-color: #f5f5f5;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.top-container {
  flex: 1;
  background-color: rgb(255, 255, 255);
  padding: 10px;
  height: 400px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
  border: 2px
   solid #ccc; /* 添加边框 */
}

.bottom-container {
  flex: 1;
  background-color: rgb(255, 255, 255);
  padding: 10px;
  height: 300px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
  border: 2px solid #ccc; /* 添加边框 */
  overflow-y: auto;
}

.link-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: left;

}

.vertical-link {
  color: #409EFF;
  text-decoration: none;
  font-size: 18px;
  display: inline-block;
}

.vertical-link:hover {
  text-decoration: underline;
}
.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 20px;
}

.card-container {
  padding: 20px;
}

.card-image {
  width: 100%;
  height: 380px;
  object-fit: cover;
}
.el-link--inner{
  display: flex;
  text-align: left
}
.top-title {
  text-align: center;
  font-size: 34px;
  font-weight: bold;
  margin-bottom: 10px;
}

.top-description {
  text-align: left;
  font-size: 18px;
  line-height: 1.8; 
}
</style>